import React from 'react'
import tw from 'twin.macro'
import Link from 'next/link'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalButton,
  SIZE as MODAL_SIZE,
  ROLE,
  ModalOverrides,
} from 'baseui/modal'
import { atom, useAtom } from 'jotai'

export const modalVisibleAtom = atom(false)

const modalOverrides: ModalOverrides = {
  Dialog: {
    style: tw`rounded-none p-4 border-2 border-solid border-brand bg-black box-border text-white text-base md:w-[615px]`,
  },
}

const primaryButtonOverrides = {
  BaseButton: {
    style: {
      ...tw`font-secondary font-semibold text-sm text-black bg-brand px-8 py-2`,
      ':hover': {color: '#000', backgroundColor: '#36fad7'},
      ':disabled': {color: '#fff', backgroundColor: '#b5b5b5'},
    },
  },
}

const secondaryButtonOverrides = {
  BaseButton: {
    style: {
      ...tw`font-secondary font-semibold text-sm text-black bg-secondary px-8 py-2`,
      ':hover': {color: '#000', backgroundColor: '#36fad7'},
      ':disabled': {color: '#fff', backgroundColor: '#b5b5b5'},
    },
  },
}

export default function InsufficientBalanceModal() {
  const [isOpen, setIsOpen] = useAtom(modalVisibleAtom)
  return (
    <Modal
      onClose={() => setIsOpen(false)}
      isOpen={isOpen}
      animate
      autoFocus
      size={MODAL_SIZE.default}
      role={ROLE.dialog}
      overrides={modalOverrides}
    >
      <ModalHeader>Insufficient Balance</ModalHeader>
      <ModalBody>
        Please keep at least 10 PHA in your account, or attribute above 0.
      </ModalBody>
      <ModalFooter>
        <ModalButton
          overrides={secondaryButtonOverrides}
          onClick={() => setIsOpen(false)}
        >
          Cancel
        </ModalButton>
        <Link
          href="https://docs.phala.world/geting-started/where-to-get-pha-khala-chain"
          target="_blank"
          legacyBehavior>
          <ModalButton
            // $as="a"
            overrides={primaryButtonOverrides}
          >
            Get PHA
          </ModalButton>
        </Link>
      </ModalFooter>
    </Modal>
  );
}